import { graphql } from '@e-socna/data-layer';
import type { Id } from '@e-socna/data-layer';

import { ThirdPartyFormTab } from '../../enums/tab.enum';

import { ThirdPartiesSelectionFormStep } from '../Selection';

import { useInitialGridState } from './hooks/useInitialGridState.hook';

export const ThirdPartyForm_BillReceiverStep_ThirdParty_Fragment = graphql(`
  fragment ThirdPartyForm_BillReceiverStep_ThirdParty_Fragment on ThirdParty {
    billReceiverId
  }
`);

interface Props {
  readonly id: string;
  readonly isInternal: boolean;
  readonly thirdPartyId?: Id;
}

export const ThirdPartyBillReceiverFormStep = ({
  isInternal,
  thirdPartyId,
}: Readonly<Props>) => {
  const { initialGridState } = useInitialGridState();

  return (
    <ThirdPartiesSelectionFormStep
      excludedIds={thirdPartyId ? [thirdPartyId] : undefined}
      fieldName="billReceiverId"
      id={ThirdPartyFormTab.BillReceiver}
      initialGridState={initialGridState}
      isInternal={isInternal}
    />
  );
};
